<template>
  <div v-if="isVisible">
    <div class="loader-overlay" id="point-loader" style="position: fixed !important;">
      <div style="height:100%;
                  display:flex;
                  justify-content: center;
                  align-items:center;">
        <atom-spinner :animation-duration="1000" :size="160" :color="'#ff1d5e'"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { AtomSpinner } from "epic-spinners";
  export default {
    name: "Loader",
    components: {
      AtomSpinner,
    },
    props: {
      isVisible: {type: Boolean, required: true},
      text: {type: String, required: false, default: ""},
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Loader.vue